/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-extraneous-dependencies */
import { useContext, useEffect, useState, useMemo, useCallback } from "react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardDescription } from "@repo/ui";
import { Grid, GridColumn, getSelectedState } from "@progress/kendo-react-grid";
import { process, getter } from "@progress/kendo-data-query";
import { PATHS } from "routes/paths";
import {
  useGetSelfMaintenanceRequests,
  useMaintenanceBulkAssign,
} from "services/maintenance";
import {
  useGetSelfPanicAlertIncidentRequests,
  usePanicAlertIncidentBulkAssign,
} from "services/panic-alert";
import Loader from "ui/page-loader";
import { BreadCrumb } from "ui/bread-crumbs";
import { FiltersContext } from "store/filters-context";
import TaskFilterBarV2 from "components/tickets/tasks-filter-bar";
import { StatusContext } from "../constants";
import {
  fixKendoGridContent,
  getTicketDetailsPage,
  isFilterUpdated,
} from "../utils";
import { useUser } from "hooks/use-user";
import GridDataCopyCell from "components/copy";
import SLACell from "../common/SLACell";

const useGetRequests = () => {
  const user = useUser();
  const CSMonitoring = useGetSelfPanicAlertIncidentRequests();
  const dispatcherTickets = useGetSelfMaintenanceRequests();
  if (user.Roles.includes("CS Monitoring")) {
    return CSMonitoring;
  }
  return dispatcherTickets;
};

const useBulkAssign = () => {
  const user = useUser();
  const panicAlertRequests = usePanicAlertIncidentBulkAssign();
  const dispatcherTickets = useMaintenanceBulkAssign();
  if (user.Roles.includes("CS Monitoring")) {
    return panicAlertRequests;
  }

  return dispatcherTickets;
};
export default function SelfAssignedTickets() {
  const [dataState, setDataState] = useState({
    sort: [
      {
        field: "code",
        dir: "asc",
      },
    ],
  });
  const [tickets, setTickets] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedState, setSelectedState] = useState({});
  const { filters } = useContext(FiltersContext);
  const { setStatus } = useContext(StatusContext);
  const [localFilters, setLocalFilters] = useState({
    searchCriteria: filters?.searchCriteria?.value || "",
    period: filters?.period?.value || "All",
    cashCenterId: filters?.cashCenterId?.value || "",
    customerId: filters?.customerId?.value || "",
    assetId: filters?.assetId?.value || "",
    activityType: filters?.activityType?.value || "",
    routeNo: filters?.routeNo?.value || "",
  });
  const user = useUser();
  const pageSize = 100;
  const DATA_ITEM_KEY = "requestId";
  const SELECTED_FIELD = "selected";
  const idGetter = getter(DATA_ITEM_KEY);

  const {
    mutate: getTickets,
    data: ticketsList,
    isPending: gettingTickets,
    reset: resetGetTickets,
  } = useGetRequests();

  const {
    mutate: bulkAssign,
    data: bulkAssignRes,
    isPending: bulkAssigning,
    error: bulkAssignError,
    reset: bulkAssignReset,
  } = useBulkAssign();

  useEffect(() => {
    if (bulkAssignRes) {
      bulkAssignReset();
    }
    if (bulkAssignError) {
      bulkAssignReset();
    }
  }, [bulkAssignRes, bulkAssignError]);

  useEffect(() => {
    setCurrentPage(1);
    getTickets({
      pageNumber: 1,
      pageRowCount: pageSize,
      ...localFilters,
    });
  }, [localFilters]);

  useEffect(() => {
    if (ticketsList) {
      setTotalRecords(ticketsList.data.totalRecords);
      setTickets(
        ticketsList.data.data.map((elm) => ({
          ...elm,
          selected: false,
        }))
      );
      resetGetTickets();
    }
  }, [ticketsList]);
  useEffect(() => {
    const nextFilters = {
      searchCriteria: filters?.searchCriteria?.value || "",
      period: filters?.period?.value || "All",
      cashCenterId: filters?.cashCenterId?.value || "",
      customerId: filters?.customerId?.value || "",
      assetId: filters?.assetId?.value || "",
      activityType: filters?.activityType?.value || "",
      routeNo: filters?.routeNo?.value || "",
    };

    if (isFilterUpdated(localFilters, nextFilters)) {
      setLocalFilters({ ...nextFilters });
    }
  }, [filters]);
  const onPageChange = (e) => {
    const _page = e.page.skip / pageSize + 1;
    setCurrentPage(_page);
    getTickets({
      pageNumber: _page,
      pageRowCount: pageSize,
      ...localFilters,
    });
  };

  const onRefresh = () => {
    getTickets({
      pageNumber: currentPage,
      pageRowCount: pageSize,
      ...localFilters,
    });
  };

  const onSelectionChange = useCallback(
    (event) => {
      const newSelectedState = getSelectedState({
        event,
        selectedState,
        dataItemKey: DATA_ITEM_KEY,
      });

      setSelectedState(newSelectedState);
    },
    [selectedState]
  );

  const onHeaderSelectionChange = useCallback((event) => {
    const checkboxElement = event.syntheticEvent.target;
    const checked = checkboxElement.checked;
    const newSelectedState = {};
    if (checked) {
      event.dataItems.forEach((item) => {
        newSelectedState[idGetter(item)] = checked;
      });
    }
    setSelectedState(newSelectedState);
  }, []);

  const onBulkAssign = (information) => {
    const selectedItems = [];
    Object.keys(selectedState).forEach((elm) => {
      if (selectedState[elm]) {
        selectedItems.push(elm);
      }
    });
    const payload = {
      cashCenterId: user.CashCenterId,
      operationDate: new Date(),
      routeNo: information.routeNo,
      dispatcherId: information.dispatcherId,
      assigneeId: information.assigneeId,
      secondaryAssigneeId: information.secondaryAssigneeId,
      requests: selectedItems.map((elm) => ({
        requestId: elm,
      })),
    };
    bulkAssign(payload);
    setSelectedState({});
  };

  const getSelectedRequests = useMemo(() => {
    return tickets.filter((elm) => selectedState[elm.requestId]);
  }, [selectedState]);

  return (
    <div className="box-border">
      {gettingTickets || bulkAssigning ? <Loader /> : <></>}
      <BreadCrumb
        className="mx-4"
        items={[
          { text: "Dashboard", to: "/" },
          { text: "Self Assigned Tickets" },
        ]}
      />
      <Card className="mx-4 mt-5">
        <CardContent>
          <CardDescription className="pt-6">
            <TaskFilterBarV2
              hideAssignmentGroup
              hideStatus
              hideAssignee
              bulkUpload
              onRefresh={onRefresh}
              selectedRequests={getSelectedRequests}
              assignTeam={onBulkAssign}
            />
          </CardDescription>

          <Grid
            data={process(
              tickets.map((item) => ({
                ...item,
                [SELECTED_FIELD]: selectedState[idGetter(item)],
              })),
              dataState
            )}
            {...dataState}
            onDataStateChange={(e) => {
              e.dataState.skip = 0;
              setDataState(e.dataState);
            }}
            className="list-tables-v1"
            filterable
            width="100%"
            sortable
            pageable
            navigatable
            total={totalRecords}
            pageSize={pageSize}
            skip={(currentPage - 1) * pageSize}
            dataItemKey={DATA_ITEM_KEY}
            selectedField={SELECTED_FIELD}
            onPageChange={onPageChange}
            selectable={{
              enabled: true,
              drag: true,
              cell: false,
              mode: "multiple",
            }}
            onSelectionChange={onSelectionChange}
            onHeaderSelectionChange={onHeaderSelectionChange}
            ref={(e) => {
              fixKendoGridContent(e);
            }}
          >
            <GridColumn
              field={SELECTED_FIELD}
              width="50px"
              filterable={false}
              headerSelectionValue={
                tickets.findIndex((item) => !selectedState[idGetter(item)]) ===
                -1
              }
            />
            <GridColumn
              title="Bank Reference"
              field="customerTicketNo"
              width="150px"
            />
            <GridColumn
              title="Ticket Number"
              width="170px"
              field="caseNo"
              cell={(items) => {
                const dataItem = items.dataItem;
                return (
                  <GridDataCopyCell
                    dataItem={items.dataItem}
                    field={items.field}
                    customCell={
                      <td>
                        <Link
                          onClick={() => {
                            setStatus("selfAssigned");
                          }}
                          to={getTicketDetailsPage(dataItem)}
                        >
                          {dataItem.caseNo}
                        </Link>
                      </td>
                    }
                  />
                );
              }}
            />
            <GridColumn
              title="Task Number"
              width="170px"
              field="taskNo"
              cell={(items) => {
                const dataItem = items.dataItem;
                return (
                  <GridDataCopyCell
                    dataItem={items.dataItem}
                    field={items.field}
                    customCell={
                      <td>
                        <Link
                          onClick={() => {
                            setStatus("selfAssigned");
                          }}
                          to={
                            dataItem.status === "Draft"
                              ? `${PATHS.createTicket}/${dataItem.ticketId}`
                              : `${PATHS.taskDetails}/${dataItem.requestId}`
                          }
                        >
                          {dataItem.status === "Draft"
                            ? "View Draft"
                            : dataItem.taskNo}
                        </Link>
                      </td>
                    }
                  />
                );
              }}
            />
            <GridColumn title="Asset Id" field="locationId" width="150px" />
            <GridColumn title="Region" field="region" width="150px" />{" "}
            <GridColumn
              title="SLA"
              field="sla"
              headerClassName="text-center"
              width="150px"
              cell={SLACell}
            />
            <GridColumn title="City" field="city" width="170px" />
            <GridColumn title="Location" field="locationName" width="170px" />
            <GridColumn
              title="Activity Type"
              field="serviceType"
              width="170px"
            />
            <GridColumn title="Category" field="fault" width="150px" />
            <GridColumn
              title="Sub Category"
              field="faultDetails"
              width="150px"
            />
            <GridColumn title="Assigned To" field="assigneeId" width="150px" />
            <GridColumn title="Route No" field="routeNo" width="150px" />
            <GridColumn
              title="Secondary Assignee"
              field="secondaryAssigneeId"
              width="150px"
            />
            <GridColumn
              title="Open At"
              field="createDateTime"
              width="120px"
              className="text-center"
              headerClassName="text-center"
            />
            <GridColumn
              title="State"
              field="status"
              width="100px"
              className="text-center"
              headerClassName="text-center"
            />
            <GridColumn title="Account" field="customer" width="170px" />
            <GridColumn
              title="Vault Access"
              field="vaultAccessRequired"
              width="150px"
            />
            <GridColumn title="Description" field="remarks" width="400px" cell={GridDataCopyCell} />
            <GridColumn
              title="Resolution Notes"
              field="resolutionNotes"
              width="170px"
              cell={GridDataCopyCell}
            />
          </Grid>
        </CardContent>
      </Card>
    </div>
  );
}
